var path = '/client/front-office/modules/content/modules/widget/modules/widget-meta/views/partials/widget-meta-updated-date.html';
var html = "<!-- Widget meta updated date -->\n<span class=\"widget-meta-updated-date\">\n    {{ vm.contentUpdatedDate }}\n</span>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;